import React, { useEffect, useState, useContext, useCallback, useRef, lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes, useNavigate, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";


import NameGuard from "./components/NameGuard";
// Importe für deine Komponenten
import PageWrapper from "./components/PageWrapper";
// KORREKTUR: Importiere CookieModal, da deine Datei so heißt
import CookieModal from "./components/CookieModal"; // <-- HIER IST DIE KORREKTUR

import callback from "./components/Callback.jsx"; // Importiere Callback-Komponente

// Import ZenCursor Customizer 

import ZenCursor from "./kits/DesignKit/ZenCursor.jsx";
import "./kits/DesignKit/zenCursor.css";


import ProfessionEditor from "./components/ProfessionEditor.jsx";
import OrbitCustomizer from "./components/OrbitCustomizer.jsx";

// import math Code 

import Math from "./components/math.jsx";

import SectionZen from "./components/SectionZen.jsx";
import BlogList from "./components/BlogList.jsx";
import NotFound from "./components/404.jsx";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Preloader from "./components/Preloader";
import { CourseProvider } from "./context/CourseContext";
import { NameProvider, NameContext } from "./context/NameContext";
import BitterButtonParentSimple from "./components/BitterButtonParentSimple";
import NameForm from "./components/NameForm";
import ScrollToTop from "./components/scrollTo.jsx";
import Kompass from "./components/Kompass";
import About from "./components/About";
import Courses from "./components/Courses";
import Course from "./components/Course";
import NewCourse from "./components/NewCourse";
import EditCourse from "./components/EditCourse";
import LoginPage from "./components/LoginAdmin";
import Register from "./components/register";
import Contact from "./components/Contact";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import AdminResetPassword from "./components/AdminResetPassword.jsx";
import ResetPassword from "./components/ResetPassword.jsx";
import CourseDetailsAndRegistration from "./components/CourseDetailsAndRegistration";
import SectionA from "./components/SectionA";
import SectionB from "./components/SectionB";

import PersonalizedMarketing from "./components/PersonaliseMarketing";
import SectionC from "./components/SectionC";
import MediaBlog from "./components/MediaBlog";
import SocialPost from "./components/SocialPost";
import Succes from "./components/Succes";
import AdminDashboard from "./components/AdminDashboard.js";
import ForgotPassword from "./components/ForgotPassword.js";
import UserDashboard from "./components/UserDashboard.jsx";
import AdminCourseCockpit from "./components/AdminCourseCockpit.jsx";
import SeoHelmet from "./components/SeoHelmet.jsx";
import PatternKit from "./kits/DesignKit/PatternKit";
import ZenListHero from "./components/ZenListHero.jsx";
import { AuthProvider } from "./auth/AuthContext";
import ProtectedRoute from "./auth/ProtectedRoute";
import LessonTabs from "./courses/LessonTabs.jsx";
import LogbookEntry from "./components/LogbookEntry.jsx";
import {PopularCourseProvider} from "./context/PopularCourseContext.js";
import Blog from "./components/Blog.jsx";
import Post from "./components/Post.jsx";
import BlogEditor from "./components/BlogEditor.jsx";
import ZenPost from "./components/ZenPost.jsx";
import CasePost from "./components/CasePost.jsx";
import LinkedinBlogEditor from "./components/LinkedinBlogEditor.jsx";
import SmartBlogEditor from "./components/SmartBlogEditor.jsx";
import SmartZenEditor from "./components/SmartZenEditor.jsx";
import Datenschutz from "./components/Datenschutz.jsx";
import Impressum from "./components/Impressum.jsx";
import SkillManager from "./components/SkillManager.jsx";
import ProjectManager from "./components/ProjectManager.jsx";
import BuildCustomCourse from "./components/BuildCustomCourse.jsx";
import UserCustomDashboard from "./components/UserCustomDashboard.jsx";
import CourseCockpitUser from "./components/CourseCockpitUser.jsx";
import BuilderPage from "./components/BuilderPage.jsx";
import AOS from 'aos';
import 'aos/dist/aos.css';

import SectionBlog from "./components/SectionBlog.jsx";
import SearchResults from "./components/SearhResults";
import ProfessionSection from "./components/ProfessionSection";
import HowItWorks from "./components/HowItWorks";
import PopularCourses from "./components/PopularCourses";
import CourseNew from "./components/CourseNew";
import CourseCopy from "./components/CourseCopy";
import ProjectDetail from "./routes/ProjectDetail";
import { PaperBG } from "./kits/index.js";
import Callback from "./components/Callback.jsx";
import SmartCaseEditor from "./components/SmartCaseEditor.jsx";

// FullLayout nur lazy laden, wenn wirklich benötigt
const FullLayout = lazy(() => import('./components/FullLayout'));


// Diese Komponente kapselt die Layout- und Navigationslogik
function AppContent() {
  const [isReady, setIsReady] = useState(false); // Für den globalen Preloader
  const location = useLocation();
  const [navbarHeight, setNavbarHeight] = useState(0); // Zustand für die dynamische Navbar-Höhe
  const navigate = useNavigate();
  const { isNameEntered = false, setNameEntered } = useContext(NameContext); // NameContext, um isNameEntered zu bekommen
  const cursorRef = useRef(null); // <-- hinzufügen

  // NEUER STATE FÜR COOKIE MODAL SICHTBARKEIT
  const [showCookieModal, setShowCookieModal] = useState(false); // <-- Hier 'showCookieModal' verwenden
  // NEUER STATE FÜR DEN INITIALEN COOKIE CONSENT ZUSTAND (wird geladen und dann an Modal übergeben)
  const [initialCookieConsent, setInitialCookieConsent] = useState(null);
  const cookieModalRef = useRef(null); // Ref für das Cookie-Modal


  // ⬇️ Steuermethoden direkt nach der Ref
  const enable = () => cursorRef.current?.enable();
  const disable = () => cursorRef.current?.disable();
  const destroy = () => cursorRef.current?.destroy();
  const reinit = () => cursorRef.current?.initialize();
  const hideTrue = () => cursorRef.current?.hideTrueCursor();
  const unhideTrue = () => cursorRef.current?.unhideTrueCursor();
  const updateFast = () => cursorRef.current?.update({ lerp: 0.3, size: 28 });
  const setPos = () => cursorRef.current?.setPosition(200, 200, false);

  // USEEFFECT für Blog zum scrollen ohne Namem 

    // 🔐 Definiere Ausnahmen für isNameEntered
  const nameBypassRoutes = [
    "/blog",
    "/post/",
    "/zen/",
    "/case/",
    "/datenschutz",
    "/impressum",
    "/lernstudio",
    "/contact"
  ];
  const isBypassed = nameBypassRoutes.some((prefix) =>
    location.pathname.startsWith(prefix)
  );


  // 3D Modell Hero vorladen 

  useEffect(() => {
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "fetch";
  link.href = "https://www.denisbitter.de/uploads/models/mac_1982.glb";
  link.crossOrigin = "anonymous";
  document.head.appendChild(link);
}, []);

  // AOS initialisieren
  useEffect(() => {
    AOS.init({ duration: 600, once: true, easing: 'ease-out' });
  }, []);






/* // neuer Preloader ohne Time 

useEffect(() => {
  const initApp = async () => {
    // Hier: echtes Laden/Authentifizieren, z.B. Cookies, API, etc.
    // await irgendwasEchtes();

    // Cookie-Zustimmung prüfen
    const stored = localStorage.getItem("cookieConsentV2");
    if (!stored) {
      setShowCookieModal(true);
      setInitialCookieConsent({
        essential: true,
        statistics: false,
        media: false,
      });
    } else {
      setInitialCookieConsent(JSON.parse(stored));
    }
    setIsReady(true); // Sobald alles geladen/gecheckt
  };
  initApp();
}, []);
 */


// alter TimeOut Preoloader 
  // Globaler Preloader für die App-Initialisierung UND Cookie-Check
  useEffect(() => {
    const initApp = async () => {
      // Simulate app-wide data loading or authentication check
      await new Promise(resolve => setTimeout(resolve, 1500)); // Globale Verzögerung
      setIsReady(true);

      // Überprüfe Cookie-Zustimmung beim App-Start
      const stored = localStorage.getItem("cookieConsentV2");
      if (!stored) {
        // Wenn keine Zustimmung gefunden, Modal anzeigen
        setShowCookieModal(true); // <-- Hier 'setShowCookieModal' verwenden
        // Initialisiere den Consent-State mit Standardwerten, da noch nichts gespeichert ist
        setInitialCookieConsent({
          essential: true,
          statistics: false,
          media: false,
        });
      } else {
        // Wenn Zustimmung gefunden, lade sie und speichere sie, aber Modal nicht anzeigen
        setInitialCookieConsent(JSON.parse(stored));
      }
    };
    initApp();
  }, []); // Leeres Array, damit dies  

  // Callback-Funktion, um die Navbar-Höhe von der Navbar-Komponente zu empfangen
  const updateNavbarHeight = useCallback((newHeight) => {
    setNavbarHeight(newHeight);
  }, []);

  // Funktion zum Schließen des Cookie-Modals
  const handleCloseCookieModal = useCallback(() => { // <-- Hier 'handleCloseCookieModal'
    setShowCookieModal(false); // <-- Hier 'setShowCookieModal' verwenden
  }, []);




  // Der globale Preloader für die gesamte App
  if (!isReady) {
    return <Preloader isReady={isReady} />;
  }

  return (
    <div className={`App ${!isNameEntered && !isBypassed ? "overflow-hidden h-screen" : ""}`}>
{isNameEntered && <Navbar updateNavbarHeight={updateNavbarHeight} />}


       {!isNameEntered && !isBypassed && <NameForm />}

      <div className="main-content" style={{ paddingTop: `${navbarHeight}px` }}>

  <ZenCursor ref={cursorRef} />
        <ScrollToTop />
        {/* HIER WIRD DAS COOKIE-MODAL BEDINGT GERENDERT */}
        {showCookieModal && ( // <-- Hier 'showCookieModal' verwenden
          <CookieModal // <-- HIER CookieModal verwenden
            ref={cookieModalRef} // Ref für Klick außerhalb
            initialConsent={initialCookieConsent} // Initialen Zustand übergeben
            onClose={handleCloseCookieModal} // <-- Hier 'handleCloseCookieModal' verwenden
          />
        )}
        {/* Die alte <CookieModal /> Zeile sollte hier entfernt werden,
            da wir jetzt die neue, gesteuerte CookieModal Komponente verwenden */}
        {/* <CookieModal />  <-- DIESE ZEILE MUSS ENTFERNT WERDEN */}

       {isNameEntered && <BitterButtonParentSimple />}
       <AnimatePresence mode="wait">
  <Routes location={location} key={location.pathname}>
    {/* Hauptseite bleibt ohne Guard */}
    <Route path="/" element={
      <>
<SeoHelmet
  title="Denis Bitter – Software Architect & Full-Stack Engineering Instructor"
  description="FullStack Entwickler, Dozent für digitale Bildung. Ich entwickle klare Systeme für Lernen, Web & App – durchdacht, echt, skalierbar. EdTech. Medien. Lösungen mit Haltung."
  url="https://www.denisbitter.de/"
  image="https://www.denisbitter.de/images/hero-og.jpg"
/>

        <PageWrapper>
          <PersonalizedMarketing id="personalized-section" />
          {isNameEntered && (
            <>
                  <HowItWorks />
            
              <SectionB />
              <ProfessionSection />
        
      
 
        
        
             
            </>
          )}
          <div className="mt-10"> <SectionZen/></div>
          <div className="mt-0">
            <PaperBG>
            <ZenListHero />
            </PaperBG>
            </div>
          <SectionBlog />
          <div>
            <PaperBG>
          <BlogList limit={3} />
          </PaperBG>
              <SectionA />
                  <PopularCourses />
                    
          </div>
                 
                <SectionC />
                
        </PageWrapper>
      </>
    } />

    {/* ALLE WEITEREN Routen um NameGuard wickeln, ausgenommen explizite Ausnahmen */}
    <Route element={<NameGuard />}>  {/* Alles darunter wird geschützt */}
     
    </Route>

    {/* AUSSNAHMEN vom Guard: öffentlich */}
    <Route path="/login" element={<PageWrapper><Login /></PageWrapper>} />
    <Route path="/loginadmin" element={<PageWrapper><LoginPage /></PageWrapper>} />
    <Route path="/blog" element={<PageWrapper><Blog /></PageWrapper>} />
    <Route path="/post/:slug" element={<PageWrapper><Post /></PageWrapper>} />
    <Route path="/zen/:slug" element={<PageWrapper><ZenPost /></PageWrapper>} />
      <Route path="/casestudy/:slug" element={<PageWrapper><CasePost /></PageWrapper>} />
    <Route path="/datenschutz" element={<PageWrapper><Datenschutz /></PageWrapper>} />
    <Route path="/impressum" element={<PageWrapper><Impressum /></PageWrapper>} />
    <Route path="/lernstudio" element={<PageWrapper><MediaBlog /></PageWrapper>} />
       <Route path="/admindashboard" element={<PageWrapper><AdminDashboard /></PageWrapper>} />
          <Route path="/about" element={<PageWrapper><About /></PageWrapper>} />
      <Route path="/course-edit/edit:slug" element={<PageWrapper><EditCourse /></PageWrapper>} />
      <Route path="/course-edit/new" element={<EditCourse />} />
      <Route path="/course/new" element={<EditCourse />} />
<Route path="/course/edit/:slug" element={<EditCourse />} />




    <Route path="*" element={<PageWrapper><NotFound /></PageWrapper>} />
     <Route path="/logbuch" element={<PageWrapper><LogbookEntry /></PageWrapper>} />
     <Route path="/orbit" element={<PageWrapper><OrbitCustomizer /></PageWrapper>} />

      <Route path="/math" element={<PageWrapper><Math /></PageWrapper>} />

      <Route path="/userdashboard" element={<PageWrapper><UserDashboard /></PageWrapper>} />
      <Route path="/courses" element={<PageWrapper><Courses /></PageWrapper>} />
      <Route path="/course/:slug" element={<PageWrapper><Course /></PageWrapper>} />
      <Route path="/new-course" element={<PageWrapper><NewCourse /></PageWrapper>} />


    <Route path="/callback" element={<PageWrapper><Callback /></PageWrapper>} />

      <Route path="/register" element={<PageWrapper><Register /></PageWrapper>} />
      <Route path="/contact" element={<PageWrapper><Contact /></PageWrapper>} /> 
      <Route path="/anmeldung/:slug" element={<PageWrapper><CourseDetailsAndRegistration /></PageWrapper>} />
      <Route path="/dashboard" element={<PageWrapper><Dashboard /></PageWrapper>} />
      <Route path="/reset-password" element={<PageWrapper><ResetPassword /></PageWrapper>} />
      <Route path="/adminresetpassword" element={<PageWrapper><AdminResetPassword /></PageWrapper>} />
      <Route path="/search" element={<PageWrapper><SearchResults /></PageWrapper>} />
      <Route path="/socialpost" element={<PageWrapper><SocialPost /></PageWrapper>} />
      <Route path="/success" element={<PageWrapper><Succes /></PageWrapper>} />
      <Route path="/kompass" element={<PageWrapper><Kompass /></PageWrapper>} />
      <Route path="/patternkit" element={<PageWrapper><PatternKit /></PageWrapper>} />
      <Route path="/lesson-tabs" element={<PageWrapper><LessonTabs /></PageWrapper>} />
      <Route path="/coursecockpit/:courseId" element={<PageWrapper><CourseCockpitUser /></PageWrapper>} />
      <Route path="/blogeditor" element={<PageWrapper><BlogEditor /></PageWrapper>} />
      <Route path="/linkedinblogeditor" element={<PageWrapper><LinkedinBlogEditor /></PageWrapper>} />
      <Route path="/buildpage" element={<PageWrapper><BuilderPage /></PageWrapper>} />
      <Route path="/smarteditor" element={<PageWrapper><SmartBlogEditor /></PageWrapper>} />
      <Route path="/smartcaseeditor" element={<PageWrapper><SmartCaseEditor /></PageWrapper>} />
      <Route path="/professioneditor" element={<PageWrapper><ProfessionEditor /></PageWrapper>} />
      <Route path="/smartzeneditor" element={<PageWrapper><SmartZenEditor /></PageWrapper>} />
      <Route path="/skillmanager" element={<PageWrapper><SkillManager /></PageWrapper>} />
      <Route path="/prmanager" element={<PageWrapper><ProjectManager /></PageWrapper>} />
      <Route path="/bausteinkurs" element={<PageWrapper><BuildCustomCourse /></PageWrapper>} />
      <Route path="/dashboard-custom" element={<PageWrapper><UserCustomDashboard /></PageWrapper>} />
      <Route path="/coursematerial" element={<PageWrapper><AdminCourseCockpit /></PageWrapper>} />
      <Route path="/forgot-password" element={<PageWrapper><ForgotPassword /></PageWrapper>} />
      <Route path="/project/:slug" element={<PageWrapper><ProjectDetail /></PageWrapper>} />
      <Route path="/course-new" element={<PageWrapper><CourseNew /></PageWrapper>} />
      <Route path="/course-copy/:id" element={<PageWrapper><CourseCopy /></PageWrapper>} />
  </Routes>
</AnimatePresence>

      </div>
      {/* Footer erhält den Callback, um das Cookie-Modal zu öffnen */}
      <Footer onShowCookieSettings={() => setShowCookieModal(true)} /> {/* <-- Hier 'setShowCookieModal' */}
    </div>
  );
}

// Dies ist deine MainApp, die die Provider und den BrowserRouter kapselt.
const MainApp = () => (
  <AuthProvider>
    <CourseProvider>
      <PopularCourseProvider>
        <BrowserRouter>
          <NameProvider> {/* NameProvider umschließt die gesamte AppContent */}
            <AppContent />
          </NameProvider>
        </BrowserRouter>
      </PopularCourseProvider>
    </CourseProvider>
  </AuthProvider>
);

export default MainApp;